// extracted by mini-css-extract-plugin
export default {"TicketInspector":"TicketInspector__oD4Ke4nx3LY6","scrollerWrapper":"scrollerWrapper__s5oBCKMDmbTE","bottomMargin":"bottomMargin__MnukbzcIxfBb"};